// removed by extract-text-webpack-plugin
module.exports = {"Calendar":"_1A3417YZZLr08yPy2F51ak","CalendarField":"HWXrQP_xQiZwQMzNy_EA-","Icon":"_2Jb4ZTfrhltklHFT6VdIzK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FortnightPickerField/index.css
// module id = 870
// module chunks = 0